module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_wifi.6aba2b01.png";